import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import { getAuth } from "firebase/auth"; // Removed unused auth

const firebaseConfig = {
  apiKey: "AIzaSyDebhi2qWr9YdYU8TuaztJ4LVyYAYgrW1s",
  authDomain: "power-wisdom-game.firebaseapp.com",
  projectId: "power-wisdom-game",
  storageBucket: "power-wisdom-game.firebasestorage.app",
  messagingSenderId: "929708294712",
  appId: "1:929708294712:web:6cbfa5a848cb2f24245ccd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig); 
const db = getFirestore(app);
// const auth = getAuth(app); // Removed unused auth

export { db }; 
